import { stories } from "../data";
import SectionHeading from "./SectionHeading";

export default function StoriesSection() {
  return (
    <section id="stories" className="bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="Highlights"
            title="往期精选作品"
            desc="这几件作品都在各自赛道拿到过高分。看它们怎么把一个普通瞬间讲成全场爆笑，比读十条规则更直观。"
          />
          <a
            href="#faq"
            className="hidden md:inline-flex items-center gap-2 px-5 py-3 rounded-md border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-800 text-sm font-medium whitespace-nowrap transition-colors shrink-0"
          >
            还有疑问？看常见问题
          </a>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {stories.map((story) => (
            <article
              key={story.title}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={story.image}
                  alt={`${story.title} —— ${story.track}赛道精选作品配图`}
                  title={`黑料大赛精选作品 · ${story.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <span className="self-start px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs">
                  {story.track}
                </span>
                <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                  {story.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{story.excerpt}</p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                  <span className="text-xs text-foreground-500 flex items-center gap-1.5">
                    <i className="ri-user-3-line" aria-hidden="true"></i>
                    {story.author}
                  </span>
                  <div className="flex items-center gap-3 text-xs">
                    <span className="flex items-center gap-1 text-primary-600">
                      <i className="ri-heart-3-fill" aria-hidden="true"></i>
                      {story.votes}
                    </span>
                    <span className="flex items-center gap-1 text-foreground-700">
                      <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                      {story.score}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}